import React from 'react';
import ReactDOM from 'react-dom/client';
import App, { renderReceiptFromHashIfPresent } from './App';

// If this page was opened via a shared receipt link (#receipt=...), render the
// receipt directly and skip the React app entirely (no login needed for viewers).
if (!renderReceiptFromHashIfPresent()) {
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(<React.StrictMode><App /></React.StrictMode>);
}
